import { Injectable, makeStateKey, PLATFORM_ID, TransferState, inject, DOCUMENT } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

interface SeoTransferData {
  title: string;
  description?: string;
  imageUrl?: string;
  url?: string;
}

const SEO_KEY = makeStateKey<SeoTransferData>('seoData');

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private titleService = inject(Title);
  private meta = inject(Meta);
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);

  updateMetaTags(title: string, description = '', imageUrl = '', url = '') {
    const fullTitle = title === 'Horizinns' ? 'Horizinns' : `${title} | Horizinns`;
    this.titleService.setTitle(fullTitle);

    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ name: 'twitter:title', content: title });

    if (description) {
      this.meta.updateTag({ name: 'description', content: description });
      this.meta.updateTag({ property: 'og:description', content: description });
      this.meta.updateTag({ name: 'twitter:description', content: description });
    }

    const finalImage = imageUrl || `${environment.appUrl}/assets/images/horizinns-cover.jpg`;
    this.meta.updateTag({ property: 'og:image', content: finalImage });
    this.meta.updateTag({ name: 'twitter:image', content: finalImage });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });

    const finalUrl = url || `${environment.appUrl}`;
    this.meta.updateTag({ property: 'og:url', content: finalUrl });
    this.meta.updateTag({ name: 'twitter:url', content: finalUrl });

    this.meta.updateTag({ property: 'og:type', content: 'website' });

    if (isPlatformServer(this.platformId)) {
      this.transferState.set(SEO_KEY, {
        title: fullTitle,
        description: description || undefined,
        imageUrl: imageUrl || undefined,
        url: url || undefined
      });
    }
  }

  addJsonLd(schema: Record<string, unknown>) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      // Remove old JSON-LD if exists
      const existing = this.document.querySelector('script[type="application/ld+json"]');
      if (existing) existing.remove();

      const script = this.document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      this.document.head.appendChild(script);
    } catch (err) {
      console.warn('Failed to add JSON-LD schema', err);
    }
  }
}
// import { Injectable, makeStateKey, PLATFORM_ID, TransferState, inject, DOCUMENT } from '@angular/core';
// import { Meta, Title } from '@angular/platform-browser';
// import { environment } from '../../../environments/environment';
// import { isPlatformBrowser, isPlatformServer } from '@angular/common';

// const SEO_KEY = makeStateKey<any>('seoData');

// @Injectable({
//   providedIn: 'root'
// })
// export class SeoService {
//   private title = inject(Title);
//   private meta = inject(Meta);
//   private transferState = inject(TransferState);
//   private platformId = inject(PLATFORM_ID);
//   private document = inject(DOCUMENT);

//   updateMetaTags(title: string, description = '', imageUrl = '', url = '') {
//     if (title === 'Horizinns') {
//       this.title.setTitle(`Horizinns`);
//     } else {
//       this.title.setTitle(`${title} | Horizinns`);
//     }
//     this.meta.updateTag({ property: 'og:title', content: title });
//     this.meta.updateTag({ name: 'twitter:title', content: title });

//     if (description) {
//       this.meta.updateTag({ name: 'description', content: description });
//       this.meta.updateTag({ property: 'og:description', content: description });
//       this.meta.updateTag({ name: 'twitter:description', content: description });
//     }
//     if (imageUrl) {
//       this.meta.updateTag({ property: 'og:image', content: imageUrl });
//       this.meta.updateTag({ name: 'twitter:image', content: imageUrl });
//       this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
//     } else {
//       this.meta.updateTag({ property: 'og:image', content: `${environment.appUrl}/assets/images/horizinns-cover.jpg` });
//       this.meta.updateTag({ name: 'twitter:image', content: `${environment.appUrl}/assets/images/horizinns-cover.jpg` });
//       this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
//     }
    
//     if (url) {
//       this.meta.updateTag({ property: 'og:url', content: url });
//       this.meta.updateTag({ name: 'twitter:url', content: url });
//     } else {
//       this.meta.updateTag({ property: 'og:url', content: `${environment.appUrl}` });
//       this.meta.updateTag({ name: 'twitter:url', content: `${environment.appUrl}` });
//     }

//     this.meta.updateTag({ property: 'og:type', content: 'website' });

//     if (isPlatformServer(this.platformId)) {
//       this.transferState.set(SEO_KEY, { title: this.title, description, imageUrl: imageUrl, url: url });
//     }
//   }

//   addJsonLd(schema: any) {
//     if (!isPlatformBrowser(this.platformId)) {
//       return;
//     }

//     try {
//       // Remove old JSON-LD if exists
//       const existing = this.document.querySelector('script[type="application/ld+json"]');
//       if (existing) existing.remove();

//       const script = this.document.createElement('script');
//       script.type = 'application/ld+json';
//       script.text = JSON.stringify(schema);
//       this.document.head.appendChild(script);
//     } catch (err) {
//       console.warn('Failed to add JSON-LD schema', err);
//     }
//   }
// }